import React, { createContext, useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";

export const GiftBasketContext = createContext();
export const useGiftBasketContext = () => useContext(GiftBasketContext);
const GiftBasketProvider = ({ children }) => {
  const [basket, setBasket] = useState([]);
  useEffect(() => {
  }, [basket]);

  let state = {
    basket,
  };
  let action = {
    addItem: (item) => {
      setBasket((prevBasket) => {
        const existingItem = prevBasket.find((data) => data.id === item.id);

        if (existingItem) {
          return prevBasket.map((data) =>
            data.id === item.id
              ? { ...data, quantity: data.quantity + 1 }
              : data
          );
        } else {
          return [...prevBasket, { ...item, quantity: 1 }];
        }
      });
    },
    removeItem: (itemId) => {
      setBasket(basket.filter((item) => item.id !== itemId));
    },
    getBasket: () => basket,
    clearBasket: () => setBasket([]),
    increaseQuantity: (itemId) => {
      setBasket((prevBasket) =>
        prevBasket.map((data) =>
          data.id === itemId ? { ...data, quantity: data.quantity + 1 } : data
        )
      );
    },
    decreaseQuantity: (itemId) => {
      setBasket((prevBasket) =>
        prevBasket
          .map((data) =>
            data.id === itemId ? { ...data, quantity: data.quantity - 1 } : data
          )
          .filter((data) => data.quantity > 0)
      );
    },
    getSummary: (special) => {
      let deliver = 500;
      if (basket?.length > 0) {
        let totalPrice = basket?.reduce(
          (acc, curr) => acc + curr.price * curr.quantity,
          0
        );
        return {
          totalItems: basket?.length,
          allQty: basket?.reduce((acc, curr) => acc + curr.quantity, 0),
          totalPrice,
          deliver,
          finalPrice: totalPrice + deliver,
          specialPoint: special,
        };
      }
      return {
        totalItems: 0,
        allQty: 0,
        totalPrice: 0,
        finalPrice: 0 + deliver,
        specialPoint: 0,
      };
    },
  };
  return (
    <GiftBasketContext.Provider value={{ ...action, ...state }}>
      {children}
    </GiftBasketContext.Provider>
  );
};

export default GiftBasketProvider;
